import { ConfigurationFieldFlag } from '../enums';

export const isRequiredConfigurationFieldFlag = (configurationFieldFlag: ConfigurationFieldFlag) =>
    configurationFieldFlag === ConfigurationFieldFlag.Required;
